// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3XXTP","buttons":"Footer_buttons__1msuF"};